import React from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import {
  COLOR_BLACK,
  COLOR_GREEN__100,
  COLOR_GREEN__LIGHT,
} from '../../lib/colors'

function UIMakerMenuLink({ text, isActive = false, dynamicStyle }) {
  return (
    <div className={css(dynamicStyle)}>
      <div className={css(styles.link, isActive && styles.isActive)}>
        <p className={css(styles.linkText)}>{text}</p>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    width: '100%',
    height: 92,
    fontWeight: 400,
  },
  linkText: {
    paddingLeft: 15,
    fontSize: 16,
    color: COLOR_BLACK,
  },
  isActive: {
    backgroundColor: COLOR_GREEN__100,
    fontWeight: 700,
    borderRightWidth: 5,
    borderRightColor: COLOR_GREEN__LIGHT,
    borderRightStyle: 'solid',
  },
})

UIMakerMenuLink.propTypes = {
  text: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  dynamicStyle: PropTypes.node,
}

export default UIMakerMenuLink
